<template>
    <div>
        <b-row>
            <b-col sm="12" md="4">
                <b-form-group>
                    <strong>
                        <label>Filtro por Status</label>
                    </strong>
                    <b-form-select
                        :plain="true"
                        :options="statusSelect"
                        v-model="status"
                        value-field="codigo"
                        text-field="descricao"
                    ></b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { computed } from 'vue'

export default {
    props: {
        servicos: {
            type: Object,
            default: () => ({}) 
        }
    },

    data() {
        return {
            statusSelect: {},
            status: null
        }
    },

    methods: {
        obterFiltros() {
            this.$store.dispatch('addRequest')
            this.servicos.obterFiltros().then(response => {
                if (response) {
                    if (response.success) {
                        this.statusSelect = response.data.statusSelect
                        this.statusSelect.unshift({
                            codigo: null, 
                            descricao: 'TODAS'
                        })
                    } else {
                        this.$toast.error(
                            'Erro ao obter filtros.',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
            this.atualizarFiltro()
        },
    
        atualizarFiltro() {
            let filtro = {
                status: this.status
            }   
            this.$emit('atualizarFiltro', filtro)
        }
    },

    created() {
        this.obterFiltros()
    },
    
    watch: {
        status() {
            this.atualizarFiltro()
        }
    }
}
</script>